module.exports = __webpack_public_path__ + "static/img/vue_logo.c9e00ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue_logo.png
// module id = U6PP
// module chunks = 1